const fromdata = [
  {
    inputdata: "",
    title: "父级菜单",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "490px",
  },
  {
    inputdata: "",
    title: "菜单编码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "",
    title: "菜单名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "",
    title: "菜单链接",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "1",
    title: "优先级",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "number",
    width: "490px",
    min: "1",
    max: "10",
  },
];
export default fromdata;
